export const MODULE_NAMESPACE = 'additional-products';

export enum DATA_MESH_IDS {
  ERROR_MODAL = 'ERROR_MODAL',
  ERROR_MODAL_TRY_AGAIN = 'ERROR_MODAL_TRY_AGAIN',
}
